import {
    IFavouriteFilterModel,
    FavouriteFilterGroupModel
} from "./../../models/favourite-filter/favourite-filter-model";
import { ActionTree } from "vuex";
import { IFavouriteFilterState } from "./favourite-filter-states.store";
import favouriteFilterTypesStore from "./favourite-filter-types.store";
import { IFavouriteFilterRequestModel } from "../../models/favourite-filter/favourite-filter-model";
import { ApiResponse } from "../../models/app-configuration";
import { favouriteFilterServicesMethod } from "../../services/favourites-filter.services";
import moduleConstant from "../../common/module-constant";

const favouriteActions: ActionTree<IFavouriteFilterState, {}> = <ActionTree<IFavouriteFilterState, {}>>{
        /**
         * ACTION: GET LIST FAVOURITES
         * STORE: LIST FILTERS
         * STORE: REQUEST PARAMS
         */
        [favouriteFilterTypesStore.Action.GET_LIST_FAVOURITES]: async ({ getters, commit }, params: IFavouriteFilterRequestModel) => {
            return getters[favouriteFilterTypesStore.Getter.GET_FAVOURITES_SERVICE]
            [favouriteFilterServicesMethod.GET_LIST_FAVOURITES](params)
                .then((response: ApiResponse) => {
                    let responseData = response.data as FavouriteFilterGroupModel[];
                    if (response.isSuccess) {
                        switch (params.Type) {
                            case moduleConstant.Object:                               
                                commit(favouriteFilterTypesStore.Mutation.UPDATE_LIST_PROPERTY_FAVOURITES, responseData);
                                break;
                            case moduleConstant.Person:
                                commit(favouriteFilterTypesStore.Mutation.UPDATE_LIST_PERSON_FAVOURITES, responseData);
                                break;
                            case moduleConstant.Demand:
                                commit(favouriteFilterTypesStore.Mutation.UPDATE_LIST_DEMAND_FAVOURITES, responseData);
                                break;
                            case moduleConstant.Task:
                                commit(favouriteFilterTypesStore.Mutation.UPDATE_LIST_TASK_FAVOURITES, responseData);
                                break;
                            default:
                                commit(favouriteFilterTypesStore.Mutation.UPDATE_LIST_FAVOURITES, responseData);
                                commit(favouriteFilterTypesStore.Mutation.UPDATE_CURRENT_REQUEST_MODEL, params);
                                break;
                        }
                    }
                    return Promise.resolve(response);
                });
        },
        
        /**
         * ACTION: SET DEFAULT FAVOURITE
         */
        [favouriteFilterTypesStore.Action.GET_DETAIL_FAVOURITE]: async ({ getters, commit }, data: any) => {
            return getters[favouriteFilterTypesStore.Getter.GET_FAVOURITES_SERVICE]
            [favouriteFilterServicesMethod.GET_DETAIL_FAVOURITE](data)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        commit(favouriteFilterTypesStore.Mutation.UPDATE_CURRENT_FAVOURITE, response.data);
                        commit(favouriteFilterTypesStore.Mutation.UPDATE_ORIGINAL_FAVOURITE, response.data);
                    }
                    return Promise.resolve(response);
                });
        },

        /**
         * ACTION: ADD NEW FAVOURITE
         */
        [favouriteFilterTypesStore.Action.ADD_FAVOURITE]: async (
            { getters, commit },
            request: IFavouriteFilterModel
        ) => {
            return getters[favouriteFilterTypesStore.Getter.GET_FAVOURITES_SERVICE]
            [favouriteFilterServicesMethod.ADD_FAVOURITE](request)
              .then((response: ApiResponse) => {
                    commit(favouriteFilterTypesStore.Mutation.UPDATE_ORIGINAL_FAVOURITE, request);
                    return Promise.resolve(response);
                });
        },

        /**
         * ACTION: UPDATE FAVOURITE
         */
        [favouriteFilterTypesStore.Action.UPDATE_FAVOURITE]: async (
            { getters, commit },
            request: IFavouriteFilterModel
        ) => {
            return getters[favouriteFilterTypesStore.Getter.GET_FAVOURITES_SERVICE]
            [favouriteFilterServicesMethod.UPDATE_FAVOURITE](request)
                .then((response: ApiResponse) => {
                    return Promise.resolve(response);
                });
        },

        /**
         * ACTION: UPDATE FAVOURITE
         */
        [favouriteFilterTypesStore.Action.DELETE_FAVOURITE]: async (
            { getters, commit },
            id: number
        ) => {
            return getters[favouriteFilterTypesStore.Getter.GET_FAVOURITES_SERVICE]
            [favouriteFilterServicesMethod.DELETE_FAVOURITE](id)
                .then((response: ApiResponse) => {
                    return Promise.resolve(response);
                });
        },

        /**
         * ACTION: UPDATE DEFAULT FAVOURITE
         */
        [favouriteFilterTypesStore.Action.UPDATE_DEFAULT_FAVOURITE]: async (
            { getters, commit },
            request: IFavouriteFilterModel
        ) => {
            return getters[favouriteFilterTypesStore.Getter.GET_FAVOURITES_SERVICE]
                [favouriteFilterServicesMethod.UPDATE_DEFAULT_FAVOURITE](request).then((response: ApiResponse) => {
                    commit(favouriteFilterTypesStore.Mutation.UPDATE_DEFAULT_FAVOURITE, request);
                    return Promise.resolve(response);
                });
        }
    };

export default favouriteActions;
